
export const compareTwoArrays = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
        return false;
    }

    return arr1.every((value) => arr2.includes(value));
}